import type { AttributeReviewDraftSelection } from "@/hooks/useAttributeReview.types";

type Pool = { key: string } & Record<string, unknown>;
type Item = {
  kind?: string | null;
  leaf?: string | null;
  path?: unknown;
  pool?: Pool | null;
  values?: unknown[] | null;
  remapped?: { path?: unknown; pool?: Pool | null; values?: unknown[] } | null;
};

export type PickPart = "leaf" | "kind" | "path";
export type PickDifference = { part: PickPart; saved: string; picked: string };

const PARTS: PickPart[] = ["leaf", "kind", "path"];

export function pickDifferences(
  item: Item,
  draft: AttributeReviewDraftSelection | undefined,
): PickDifference[] {
  return PARTS.filter(
    (part) => draft?.[part] !== undefined && draft[part] !== item[part],
  ).map((part) => ({
    part,
    saved: String(item[part] ?? "—"),
    picked: String(draft?.[part] ?? "—"),
  }));
}

export function shownAnswer(
  item: Item,
  draft: AttributeReviewDraftSelection | undefined,
) {
  if (pickDifferences(item, draft).length === 0)
    return { pool: item.pool ?? null, values: item.values ?? [] };
  const remapped = item.remapped;
  return remapped && remapped.path === draft?.path
    ? { pool: remapped.pool ?? null, values: remapped.values ?? [] }
    : { pool: null, values: [] };
}
